<template>
  <div class="video-container" v-if="$store.state.testeeStatus !== 'COMPLETED'" v-show="$store.state.cameraEnabled">
    <video ref="proctoringFeed" id="candidate-video" autoplay></video>
    <canvas v-show="false" id="candidate-frame" ref="canvas" :width="493" :height="300"></canvas>
    <!-- <button type="button" class="next-button" @click="getFrame">take</button> -->
  </div>
</template>

<script>
import api from '../services/api.service'
import axios from 'axios'
export default {
  name: 'ProctoringStream',
  data() {
    return {
      micStream: null,
      cameraStream: null,
      recorder: null,
      presignedUrl: null,
      randTime: 5,
    }
  },
  async created() {
    console.log('Proctoring stream is rendered')
    let devices = await this.checkMediaDevices()
    if(this.$store.state.cameraEnabled){
      if(devices['cam'] == true && await this.getCameraPermission()){
        this.startCameraStream();
      }
    }
    if(this.$store.state.micEnabled){
      if(devices['mic'] == true && await this.getMicPermission()){
        this.startMicStream();
      }
    }
  },
  mounted() {
    if(this.$store.state.cameraEnabled) {
      this.startProctoring()
    }
  },
  beforeDestroy() {
    this.clean()
  },
  methods: {
    async getCameraPermission(){
      try {
        await navigator.mediaDevices.getUserMedia({video: true}).then( (stream) =>{
          let tracks = stream.getTracks()
          tracks.forEach((track) => {
            track.stop()
          })
        })
        this.submitCamError = ''
        return true
      } catch {
        return false
      }
    },
    async getMicPermission(){
      try {
        await navigator.mediaDevices.getUserMedia({audio: true}).then( (stream) =>{
          let tracks = stream.getTracks()
          tracks.forEach((track) => {
            track.stop()
          })
        })
        this.submitMicError = ''
        return true
      } catch {
        return false
      }
    },
    async getUserPermission() {
      let permissions = {
        cam: await this.getCameraPermission(),
        mic: await this.getMicPermission()
      }
      return permissions
    },
    async checkMediaDevices() {
      const devices = await navigator.mediaDevices.enumerateDevices()
      let micFound = devices.some(device => device.kind === "audioinput")
      let camFound = devices.some(device => device.kind === "videoinput")
      let devicesFound = {
        cam: camFound,
        mic: micFound
      }

      return devicesFound
    },
    async uploadToS3(frame) {

      const response = await api.getPresignedUrl(this.$route.params.test_id, this.$store.state.userId)

      // console.log(frame)

      if(response['status'] === 'OK')
      {

        let url = response['data']

        axios.put(url, frame, {
          headers: {
            'Content-Type': 'image/jpeg'
          }
        })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
      }
      else if(response['status'] === 'ERROR')
      {
        console.log(response['message']);
      }

    },
    getFrame() {

      const context = this.$refs.canvas.getContext('2d')
      context.drawImage(this.$refs.proctoringFeed, 0, 0, 493, 300)

      const canvas = document.getElementById('candidate-frame')

      canvas.toBlob(
        async (blob) => {
          // console.log(blob)
          // console.log(typeof(blob))
          const type = 'image/jpeg'
          const frame = new File([blob], 'demo', { lastModified: new Date().getTime(), type });
          await this.uploadToS3(frame)
        },'image/jpeg', 1);

    },
    randomIntFromInterval(min, max) { // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    startProctoring(){
      this.$store.commit(
        'setProctoringTimer',
        setTimeout( () => {
        this.getFrame()
        this.randTime = this.randomIntFromInterval(15,30);
        this.startProctoring();
      }, this.randTime * 1000));
    },
    startCameraStream() {
      const constraints = {
        video: true,

      }
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.$refs.proctoringFeed.srcObject = stream
          this.cameraStream = stream
        })
        .catch((error) => {
          alert("Browser doesn't support or there is some errors." + error)
        })
    },
    startMicStream() {
      navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            this.recorder = new MediaRecorder(stream)
            this.recorder.start()
            this.micStream = stream
          })
          .catch((error) => {
            alert("Browser doesn't support or there is some errors." + error)
          })
    },
    stopCameraStream() {
      try{
        let tracks = this.cameraStream.getTracks()
        tracks.forEach((track) => {
          track.stop()
        })
        this.recorder.stop()
      }
      catch{}
    },
    stopMicStream() {
      try{
        let tracks = this.micStream.getTracks()
        tracks.forEach((track) => {
          track.stop()
        })
        this.recorder.stop()
      }
      catch{}
    },
   async  clean() {
      this.stopCameraStream()
      this.stopMicStream()
      clearTimeout(this.$store.state.proctoringTimer)
    }
  }
}
</script>

<style>
#candidate-video {
  background: black;
}

.video-container {
  display: flex;
  justify-content: center;
  position: absolute;
  /* pointer-events: none; */
  top: 0px;
  left: calc(50% - 82px);
  height: 64px;
  width: 164px;
}

.next-button {
  width: 63px;
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  background: #526aff;
  border-radius: 4px;
  margin-top: 8px;
}

</style>
